/**
 * Navigation Badge Counts API Service
 *
 * Provides counts for notification badges in the app navigation.
 * Lightweight endpoint that returns counts for urgent items.
 */

import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithErrorHandling } from './baseQuery';

export interface NavBadgeCounts {
  /** Matters in Initial Review status where user is managing paralegal */
  initial_review_matters_count: number;
  /** Immediate/Urgent priority tasks assigned to user */
  high_priority_tasks_count: number;
}

export const navBadgeApiClient = createApi({
  reducerPath: 'navBadgeApi',
  baseQuery: baseQueryWithErrorHandling,
  tagTypes: ['NavBadgeCounts'],
  endpoints: (builder) => ({
    getNavBadgeCounts: builder.query<NavBadgeCounts, void>({
      query: () => 'api/nav-badge-counts/',
      providesTags: ['NavBadgeCounts'],
    }),
  }),
});

export const { useGetNavBadgeCountsQuery } = navBadgeApiClient;
